require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./newsletter-aug-2023.json") })
        }
      }, "path---newsletter-aug-2023");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---newsletter-aug-2023!./.cache/json/newsletter-aug-2023.json
// module id = 1173
// module chunks = 231608221292675